import React from 'react';

const cols = {
  Product: [{ l: 'Features', h: '#features' }, { l: 'How It Works', h: '#how-it-works' }, { l: 'FAQ', h: '#faq' }],
  Resources: [{ l: 'GitHub', h: 'https://github.com/suhaas-lokare/Bonk', x: 1 }, { l: 'Documentation', h: 'https://github.com/suhaas-lokare/Bonk/blob/main/README.md', x: 1 }, { l: 'Issues', h: 'https://github.com/suhaas-lokare/Bonk/issues', x: 1 }],
  Legal: [{ l: 'MIT License', h: '#' }, { l: 'Privacy', h: '#' }],
};

export default function Footer() {
  const go = (e, h) => { if (!h.startsWith('#') || h === '#') return; e.preventDefault(); document.querySelector(h)?.scrollIntoView({ behavior: 'smooth' }); };

  return (
    <footer data-testid="footer" style={{ borderTop: '1px solid rgba(255,255,255,0.04)', padding: '64px 0 32px' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 48, marginBottom: 64 }} className="ft-grid">
          <div>
            <span style={{ fontFamily: 'var(--heading)', fontWeight: 800, fontSize: 17, letterSpacing: '-0.03em' }}>bonk<span style={{ color: '#FF5E3A' }}>.</span></span>
            <p style={{ color: '#52525B', fontSize: 13, lineHeight: 1.7, marginTop: 12, maxWidth: 240 }}>Professional metadata editor for DJs. Open source.</p>
          </div>
          {Object.entries(cols).map(([title, links]) => (
            <div key={title}>
              <h4 style={{ fontFamily: 'var(--mono)', fontSize: 10, fontWeight: 600, color: '#3F3F46', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 16 }}>{title}</h4>
              {links.map(l => (
                <a key={l.l} href={l.h} onClick={e => go(e, l.h)} target={l.x ? '_blank' : undefined} rel={l.x ? 'noopener noreferrer' : undefined}
                  data-testid={`footer-link-${l.l.toLowerCase().replace(/\s/g,'-')}`}
                  style={{ display: 'block', color: '#71717A', fontSize: 13, marginBottom: 10, transition: 'color .2s' }}
                  onMouseEnter={e => e.target.style.color = '#E4E4E7'} onMouseLeave={e => e.target.style.color = '#71717A'}
                >{l.l}</a>
              ))}
            </div>
          ))}
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.04)', paddingTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span style={{ fontFamily: 'var(--mono)', fontSize: 11, color: '#3F3F46' }}>2025 Bonk</span>
          <span style={{ fontFamily: 'var(--mono)', fontSize: 11, color: '#3F3F46' }}>Built for the DJ community</span>
        </div>
      </div>
      <style>{`@media(max-width:768px){.ft-grid{grid-template-columns:1fr 1fr !important}}`}</style>
    </footer>
  );
}
